
export default {
    productData: {
        serialNumber: 'DA-HMS-010',
        name: 'Holzbalkendecke mit Schalldämmplatten l Aufbau 10',
        construction: {
        composition: [
            {
            type: 'screed',
            title: { de: 'Estrich' },
            output: 'ohne',
            value: 'nw-0'
            },
            {
            type: 'soundInsulation',
            title: { de: 'Schalldämmplatte' },
            output: '2 x 10 mm',
            value: 'si-20'
            },
            {
            type: 'insulation',
            title: { de: 'Holzfaserdämmplatte' },
            output: '≥ 20',
            value: 'w-20'
            },
            {
            type: 'fill',
            title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 132 kg/m<sup>2</sup>), Rieselschutz' },
            output: '≥ 80',
            value: 'scsb-80'
            },
            {
            type: 'woodenPanel',
            title: { de: 'Holzwerkstoffplatte HW' },
            output: '≥ 22',
            value: 22
            },
            {
            type: 'supportingStructure',
            title: { de: 'Balken' },
            output: '240',
            value: 'b-240'
            },
            {
                type: 'suspendedCeiling',
                title: { de: 'Hohlraumdämpfung' },
                output: '2 x 120',
                value: 'h-240'
              },
            {
            type: 'suspendedCeiling',
            title: { de: 'Federschiene' },
            output: '25',
            value: 'f-25'
            },
            {
                type: 'soundInsulation',
                title: { de: 'Schalldämmplatte' },
                output: '12,5',
                value: 'g-12.5'
              },
              {
                type: 'suspendedCeiling',
                title: { de: 'Gipsplatte GKFI' },
                output: '12,5',
                value: 'g-12.5'
              }
        ],
        sum: {
            output: '432', value: 432
        }
        },
        technicalValues: {
        impactSoundLevel: { // L,nw
            output: '32 (2; 9)',
            value: 32
        },
        soundReductionIndex: { // Rw
            output: '84 (-3; -10)',
            value: 84
        },
        heatTransferCoefficient: { // U-Wert
            output: '0,18',
            value: 0.18
        },
        fireResistance: {
          output: '-', value: null
        },
        massPerUnitArea: {
          output: '239,6 [kg/m²]'
        }
        }
    },
    image: 'da-hms-010.png',
    pdf: 'Holzbalkendecke-mit-Schalldämmplatten-Aufbau-10-DA-HMS-010-Rev01.pdf'
    }
  
